import React from "react";
import { Routes, Route } from "react-router-dom";
import { CorrelacaoPares } from "../../../pages";

const CorrelacoesRoutes = () => {
  return (
    <Routes>
      {/* <Route path={"/analise"} element={<CorrelacaoCarteira />} />
      <Route path={"/pares"} element={<CorrelacaoPares />} /> */}
      <Route path={"*"} element={<CorrelacaoPares />} />
    </Routes>
  );
};

export default CorrelacoesRoutes;
